import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f44d9ff4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container container--animation container--wide" }
const _hoisted_2 = { class: "tasks-page" }
const _hoisted_3 = { class: "aside aside--left" }
const _hoisted_4 = { class: "form" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title title--h3" }, " Фильтрация ", -1))
const _hoisted_6 = { class: "container" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, " Список задач ", -1))
const _hoisted_8 = { class: "tasks-container" }
const _hoisted_9 = { class: "aside aside--right" }

import TasksList from '@/components/TasksList.vue';
import TaskForm from '@/components/TaskForm.vue';
import BasicSelect from '@/components/UI/BasicSelect.vue';
import BasicTextInput from '@/components/UI/BasicTextInput.vue';
import { useStore } from 'vuex';
import { computed, onUnmounted, ref } from 'vue';
import { createNamespacedHelpers } from 'vuex-composition-helpers';
import { Task } from '@/types/task';
import { SortOption } from '@/types/sortOptions';
import { useTasks } from '@/hooks/useTasks';

export default /*#__PURE__*/_defineComponent({
  __name: 'TodoList',
  setup(__props) {

const taskModule = createNamespacedHelpers('taskModule');
const authModule = createNamespacedHelpers('authModule');

const state = ref<Task[]>(null);
const store = useStore();
const taskState = store.state.taskModule;
const { addTask, stopListener } = taskModule.useActions(['addTask', 'stopListener']);
const { getSortedAndSearchedActiveTasks, getSortedAndSearchedCompletedTasks } = taskModule.useGetters(['getSortedAndSearchedActiveTasks', 'getSortedAndSearchedCompletedTasks']);
const { setSelectedSort, setSearchQuery } = taskModule.useMutations(['setSelectedSort', 'setSearchQuery']);
const { fetchUser } = authModule.useActions(['fetchUser']);

const { isLoading, isError, getTasksFromDB } = useTasks(state, store);

const selectedSort = computed((): string => taskState.selectedSort);
const searchQuery = computed((): string => taskState.searchQuery);
const sortOptions = computed((): SortOption[] => taskState.sortOptions);

fetchUser();
getTasksFromDB();

onUnmounted(() => {
  stopListener()
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("aside", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(BasicTextInput, {
            id: "search",
            name: "search",
            label: "поиск",
            "model-value": searchQuery.value,
            "onUpdate:modelValue": _unref(setSearchQuery)
          }, null, 8, ["model-value", "onUpdate:modelValue"]),
          _createVNode(BasicSelect, {
            "model-value": selectedSort.value,
            options: sortOptions.value,
            "onUpdate:modelValue": _unref(setSelectedSort)
          }, null, 8, ["model-value", "options", "onUpdate:modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createVNode(TasksList, {
            "is-loading": _unref(isLoading),
            "is-error": _unref(isError),
            tasks: _unref(getSortedAndSearchedActiveTasks)
          }, null, 8, ["is-loading", "is-error", "tasks"]),
          _createVNode(TasksList, {
            "is-loading": _unref(isLoading),
            "is-error": _unref(isError),
            completed: true,
            tasks: _unref(getSortedAndSearchedCompletedTasks)
          }, null, 8, ["is-loading", "is-error", "tasks"])
        ])
      ]),
      _createElementVNode("aside", _hoisted_9, [
        _createVNode(TaskForm, { onAddTask: _unref(addTask) }, null, 8, ["onAddTask"])
      ])
    ])
  ]))
}
}

})